import React, { Component } from 'react';
import Tabletop from 'tabletop';

class Videos extends Component {
	constructor() {
		super()
		this.state = {
			data: []
		}
	}

	componentDidMount() {
		Tabletop.init({
			key: '1pOk4gANazPxC_gfHyXoriLNOiQvb0dnvK52kh_L6SGA',
			callback: googleData => {
				this.setState({
					data: googleData
				})
			},
			simpleSheet: true
		})
	}

	render() {
		const { data } = this.state
		return (
			<div className="Videos">
				<div className="flex content-center">
					<div className="flex-grow self-center px-4">
						<h2 className="mb-6">Video Highlights</h2>
					</div>
				</div>

				<div class="flex flex-wrap overflow-hidden -mx-2">
					<div class="w-1/2 px-6 mb-6 overflow-hidden">
						<h3 className="mb-4">Yas Marina</h3>
						<div class="videoWrapper">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/kpYUZjsf62g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>

					<div class="w-1/2 px-6 mb-6 overflow-hidden">
						<h3 className="mb-4">Brands Hatch</h3>
						<div class="videoWrapper">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/dDcgepj-U_g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>

					<div class="w-1/2 px-6 mb-6 overflow-hidden">
						<h3 className="mb-4">Bahrain</h3>
						<div class="videoWrapper">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/qw7dvXlQ3aE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>

					<div class="w-1/2 px-6 mb-6 overflow-hidden">
						<h3 className="mb-4">Nordschleife</h3>
						<div class="videoWrapper">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/RmcsxG6aN8M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Videos;
